export default __webpack_public_path__ + "static/media/maintenance.7720e334.svg";